import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import configs from '../../config/config';
import { isMobile } from 'react-device-detect';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { openLeagueMenu } from "../../store/actionCreators/club";
import '../../assets/stylesheets/ClubSlide/LeagueGamesMenu.scss'
import { requestGames } from '../../store/actionCreators/casinoGames';
import { getClubProducts, getGlobalClub } from '../../store/selectors';

export default function LeagueGamesMenu(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [gameTypes, setGameTypes] = useState(['poker']);
    const leagueMenu = useSelector(state => state.leagueMenu);
    const prods =  useSelector(getClubProducts);
    const gbClub= useSelector(getGlobalClub);
    const clubProducts = useMemo(() => !!gbClub && prods[gbClub.clubId] ? prods[gbClub.clubId] : [], [prods, gbClub]);

    const onOpenLeagueMenu = useCallback((e) => dispatch(openLeagueMenu()), [leagueMenu, openLeagueMenu]);

    useEffect(() => {
        setGameTypes(configs.supportedTabs.filter(g => clubProducts.includes(g)));
    }, [clubProducts]);

    return (
        <div className={`leagueGames`}>
            <div className={`leagueWrapper ${leagueMenu ? 'opened' : 'closed'}`}>
                <div className={'leagueGamesHeader'} onClick={() => onOpenLeagueMenu()}>
                    <button className={`closeButton`}>
                        <FontAwesomeIcon icon={faChevronUp} color="white" className="fa chevron-up"></FontAwesomeIcon>
                    </button>
                    <span>{t('clubLeague')}</span>
                </div>
                <div className={'leagueContent'}>
                    {
                        gameTypes.map((game, index) =>
                            <Link key={index} className={`gameButton ${game}`} to={`/league/${game}`}>{t(`tabTitle.${game}`)}</Link>
                        )
                    }
                </div>
            </div>
        </div>
    );
}
